var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.IOListData),function(IOData){return _c('IO',{key:IOData.key,staticClass:"io",attrs:{"IOData":IOData,"agencyId":_vm.agencyId,"selectedPointGroup":_vm.selectedPointGroup}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }